import { atom, getDefaultStore, useAtomValue } from 'jotai';

const perfDebugModeEnabledAtom = atom(false);

// hot path (perfCount / onPerfRender) から jotai store を引かずに済むよう、同じ値をモジュール変数にも持つ
let perfDebugModeEnabled = false;

/**
 * `?debug=perf` のパフォーマンス計測機能の有効・無効を設定する。
 * URLのdebugフラグだけでなく利用者の判定も伴うため、判定結果をここに集約して各所から参照する。
 */
export const setPerfDebugModeEnabled = (enabled: boolean): void => {
  perfDebugModeEnabled = enabled;
  getDefaultStore().set(perfDebugModeEnabledAtom, enabled);
};

export const isPerfDebugModeEnabled = (): boolean => perfDebugModeEnabled;

export const useIsPerfDebugMode = (): boolean => useAtomValue(perfDebugModeEnabledAtom);
